import { Inject, Injectable } from '@angular/core';
import { IAppConfig } from './config/app-config.model';
import { APP_CONFIG } from './config/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class XnStorageService {
  private prefix: string = '';

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ) {
    if(config.storeKey){
      this.prefix = config.storeKey;
    }
  }

  setItem(key: string, item: any){
    localStorage.setItem(this.getKey(key), JSON.stringify(item));
  }

  getItem(key: string){
    const str = localStorage.getItem(this.getKey(key));
    if(!str) return;
    try {
      const item = JSON.parse(str);
      return item;
    } catch (error) {
      return undefined;
    }
  }

  private getKey(key: string){
    return `${this.prefix || ''}${key}`;
  }

  removeItem(key: string){
    localStorage.removeItem(this.getKey(key));
  }

  clear(){
    localStorage.clear();
  }
}